import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { TeamDto } from '../../../commonTypes/organization.types';

const useHttpGetTeamByIdOnMount = (id?: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [team, setTeam] = useState<TeamDto>();
    const [isReady, setIsReady] = useState<boolean>(false);

    const getTeamById = (id: string) => {
        const { exec, abort } = organizationApi.getTeam({
            params: { id },
            onSuccess: res => {
                setTeam(res.body);
            },
            onError: err => err,
            onFinally: () => {
                setIsReady(true);
            },
        });
        exec();
        return abort;
    };

    useEffect(() => {
        if (id) getTeamById(id);
    }, []);

    return { team, isReady };
};

export default useHttpGetTeamByIdOnMount;
